import { render, staticRenderFns } from "./TemplateEditor.vue?vue&type=template&id=2c153d68&scoped=true&"
import script from "./TemplateEditor.vue?vue&type=script&lang=js&"
export * from "./TemplateEditor.vue?vue&type=script&lang=js&"
import style0 from "./TemplateEditor.vue?vue&type=style&index=0&id=2c153d68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c153d68",
  null
  
)

export default component.exports